"use client";

import React, { useEffect } from "react";
import { useModal } from "@/contexts/ModalContext";
import { cn } from "@/lib/utils";
import { createPortal } from "react-dom";
import { useTranslations } from "next-intl";
import { Heading } from "@/components/typography/Heading";
import { Button } from "@/components/ui/Button";

export const Modal: React.FC = () => {
  const { modal, closeModal } = useModal();
  const t = useTranslations();

  if (!modal.isOpen || !modal.config) return null;

  const { title, size = "md", content, actions } = modal.config;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
  };

  if (typeof window === "undefined") return null;
  return createPortal(
    modal.isOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div
          className="fixed inset-0 bg-black/80"
          onClick={closeModal}
        />
        <div className={cn("relative z-50 max-h-[90vh] overflow-auto rounded-lg border bg-background p-6 shadow-lg", sizeClasses[size])}>
          <Button
            variant="ghost"
            onClick={closeModal}
            className="absolute right-4 top-1.5 opacity-70 p-0"
          >
            <span className="sr-only">{t("general.close")}</span>
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </Button>

          {title && (
            <div className="mb-4 pr-8">
              <Heading as="h2" size="lg">{title}</Heading>
            </div>
          )}
          <div className="py-4">{content}</div>
          {actions && <div className="mt-4 flex justify-end gap-2">{actions}</div>}
        </div>
      </div>
    ),
    document.body,
  );
};
